import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { safeValue, ConfigService, buildPath } from '@identic/core';
import { BaseService } from '@identic/api';
import { GradingViewModel, GRADING_DISPLAY_FIELD } from './+state';
import { GradingConstants } from './data-access.constants';

// R(oute)T(oken)
const RT = GradingConstants;

@Injectable({providedIn: 'root'})
export class GradingService extends BaseService<GradingViewModel> {

  constructor(http: HttpClient, config: ConfigService) {
    super(http, buildPath(config.environment.API_BASE_URL, safeValue(config, 'environment.Api.Grading', RT.defaultApi)), GRADING_DISPLAY_FIELD);
  }
}
